import React from 'react'
import Helmet from 'react-helmet'

export default ({
  title = 'PlayVS',
  description = 'Join the inaugural season of North America&#x27;s sanctioned high school esports league and compete for your State Championship.',
  keywords = 'high school esports'
}) => (
  <div>
    <Helmet>
      <title>{title}</title>

      <link rel="shortcut icon" href="/static/favicon.ico" type="image/x-icon" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />

      <link
        rel="stylesheet"
        type="text/css"
        href="https://cloud.typography.com/6651476/7902812/css/fonts.css"
      />
      <link href="https://cdn.jsdelivr.net/npm/boxicons@1.8.1/css/boxicons.min.css" rel="stylesheet" />

      <meta property="description" content={description} />
      <meta property="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta
        property="og:description"
        content="Join the inaugural season of North America&#x27;s sanctioned high school esports league and compete for your State Championship."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.playvs.com" />
      <meta property="og:image" content="https://www.playvs.com/social-heros/fb.jpg" />

      <meta property="twitter:title" content={title} />
      <meta
        property="twitter:description"
        content="Join the inaugural season of North America&#x27;s sanctioned high school esports league and compete for your State Championship."
      />
      <meta property="twitter:image" content="https://www.playvs.com/social-heros/twitter.jpg" />
    </Helmet>
  </div>
)



// WEBPACK FOOTER //
// ./src/common/ui/components/Head.js